import React from 'react';
import OliveIcon from '@/public/icons/logo/olive.svg';
import Link from '@/components/@IntranetLibrary/Link';
import { t } from 'i18next';
import styled from '@emotion/styled';
import Congestion from './Congestion';
import Header from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/Olive/Header';
import { useMypageEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { MypageEventName } from '@/constant/gtm';
import { useAtomValue } from 'jotai/index';
import { MyInfoState } from '@/recoil/atom';
import { Box, Stack } from '@mui/material';

const Olive = () => {
  const { email } = useAtomValue(MyInfoState);
  const mypageEventTracker = useMypageEventTracker();
  const isMac = window.navigator.userAgent?.includes('Mac');

  const link = isMac
    ? 'https://apps.apple.com/kr/app/%EC%98%AC%EB%A6%AC%EB%B8%8C%EC%8B%9D%EA%B6%8C/id1189457877'
    : 'https://play.google.com/store/apps/details?id=com.erise.cybermealticket&hl=ko';

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (window.isRNWebview) {
      e.preventDefault();
      const sendData = JSON.stringify({
        actionType: 'OPEN_OLIVE_APP',
      });
      window?.ReactNativeWebView?.postMessage(sendData);
    }
  };

  return (
    <>
      <Header />
      <Congestion />
      <div style={{ padding: '12px 20px 32px 20px' }}>
        <Link
          variant={'primary'}
          href={link}
          target={'_blank'}
          rel={'noreferrer'}
          sx={{
            backgroundColor: 'var(--dk-bg, white)',
            color: 'var(--dk-text, black)',
            border: '1px solid var(--dk-line, #E7E9EC)',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
          }}
          onClick={(e) => {
            handleClick(e);

            // GA Mypage - 33번
            mypageEventTracker(MypageEventName.clickOutLink, {
              area_name: '구내식당 이용 안내',
              button_text: '올리브 식권 앱 열기',
            });
          }}
        >
          <OliveIcon width={'20px'} height={'20px'} />
          {t('MYPAGE.올리브 식권 앱 열기')}
        </Link>
        <StyledSubTitle>
          {t('MYPAGE.위 버튼을 눌러 앱에서 확인해 주세요.')}
        </StyledSubTitle>
      </div>
      <Divider />
      <Stack
        direction={'column'}
        gap={'8px'}
        sx={{ padding: '24px 20px', fontSize: '14px' }}
      >
        <Box>{t('MYPAGE.로그인 계정 정보')}</Box>
        <Stack direction={'row'} gap={'4px'}>
          <Box sx={{ width: '80px', color: 'var(--dk-text-secondary, #888D96)' }}>{t('이메일')}</Box>
          <Box>{email}</Box>
        </Stack>
        <Stack direction={'row'} gap={'4px'}>
          <Box sx={{ width: '80px', color: 'var(--dk-text-secondary, #888D96)' }}>{t('비밀번호')}</Box>
          <Box>{t('MYPAGE.올리브 식권 앱에서 설정')}</Box>
        </Stack>
      </Stack>
    </>
  );
};

export default Olive;

const Divider = styled.div`
  width: 100%;
  height: 8px;
  background-color: var(--dk-bg-subtle, #f9fafb);
`;

const StyledSubTitle = styled.div`
  margin-top: 10px;
  font-size: 14px;
  color: var(--dk-text-secondary, #888d96);
  font-weight: 400;
  line-height: 20px;
  text-align: center;
`;
